/*
  Kalessie - "Load more" for the collection grid. Progressive enhancement over
  Shopify pagination: fetches the next page via the Section Rendering API and
  appends its grid items, then fires kal:grid-appended so the filter re-applies.
  No-JS fallback: the button is a real link to ?page=N.
*/
(function () {
  var btn = document.querySelector('[data-kal-load-more]');
  if (!btn) return;
  var grid = document.getElementById('product-grid');
  if (!grid) return;
  var sectionId = btn.getAttribute('data-section-id');

  btn.addEventListener('click', function (e) {
    var next = btn.getAttribute('data-next-url');
    if (!next || !sectionId) return; // let the link navigate as fallback
    e.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    var label = btn.textContent;
    btn.textContent = 'Loading…';

    var url = next + (next.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sectionId);
    fetch(url, { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.getElementById('product-grid');
        if (newGrid) {
          Array.prototype.slice.call(newGrid.children).forEach(function (li) { grid.appendChild(li); });
          document.dispatchEvent(new CustomEvent('kal:grid-appended'));
        }
        // Update or remove the button based on the fetched page's own load-more.
        var newBtn = doc.querySelector('[data-kal-load-more]');
        if (newBtn && newBtn.getAttribute('data-next-url')) {
          btn.setAttribute('data-next-url', newBtn.getAttribute('data-next-url'));
          btn.textContent = newBtn.textContent;
          btn.setAttribute('href', newBtn.getAttribute('href') || '#');
          btn.removeAttribute('aria-busy');
        } else {
          btn.parentNode.removeChild(btn);
        }
      })
      .catch(function () { window.location = next; });
  });
})();
